import {AwAppShell, AwAvatar, AwBadge, AwErrorState, AwLoadingState, AwPageHeader, AwPanel} from '@ascension-tracker/ascension-ui';
import {useProjectIdForKey} from './ProjectPage.js';
import {useProjectMembers} from '../hooks/useProjectMembers.js';

const roleLabels: Record<string, string> = {
  administrator: 'Administrator',
  member: 'Member',
  viewer: 'Viewer'
};

export function People({projectKey}: {projectKey: string}) {
  const {projectId, error} = useProjectIdForKey(projectKey);
  if (error) return <AwAppShell projectKey={projectKey}><AwErrorState>{error}</AwErrorState></AwAppShell>;
  if (!projectId) return <AwAppShell projectKey={projectKey}><AwLoadingState/></AwAppShell>;
  return <PeopleList projectKey={projectKey} projectId={projectId}/>;
}

function PeopleList({projectKey, projectId}: {projectKey: string; projectId: string}) {
  const members = useProjectMembers(projectId);
  return (
    <AwAppShell projectKey={projectKey}>
      <AwPageHeader eyebrow={`Project: ${projectKey}`} title="People">
        <p>Everyone with access to this project.</p>
      </AwPageHeader>
      {members.error && <AwErrorState>{(members.error as Error).message}</AwErrorState>}
      {!members.data ? <AwLoadingState/> : members.data.length === 0 ? (
        <AwPanel><p className="task-detail__muted">No members yet.</p></AwPanel>
      ) : (
        <div className="people-grid">
          {members.data.map(member => (
            <AwPanel key={`${member.principalType}-${member.principalId}`} className="people-card">
              <AwAvatar name={member.displayName}/>
              <div>
                <strong>{member.displayName}</strong>
                {member.email && <span>{member.email}</span>}
              </div>
              <AwBadge>{roleLabels[member.role] ?? member.role}</AwBadge>
            </AwPanel>
          ))}
        </div>
      )}
    </AwAppShell>
  );
}
